import { render, staticRenderFns } from "./shortcutPop.vue?vue&type=template&id=93a9c35c&"
import script from "./shortcutPop.vue?vue&type=script&lang=js&"
export * from "./shortcutPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "0f7a9226"
  
)

export default component.exports